import React from 'react';
import * as d3 from '../../../libraries/d3';

export default class VerticalBars extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  };

  componentDidMount(prevProps) {
    var filter = this.props.bounds().append("filter")
      .attr("id", "drop-shadow")
      .attr("height", "130%")

    filter.append("feGaussianBlur")
      .attr("in", "SourceAlpha")
      .attr("stdDeviation", 5)
      .attr("result", "blur");

    filter.append("feOffset")
      .attr("in", "blur")
      .attr("dx", -5)
      .attr("dy", -5)
      .attr("result", "offsetBlur");

    var feMerge = filter.append("feMerge");

    feMerge.append("feMergeNode")
      .attr("in", "offsetBlur")
    feMerge.append("feMergeNode")
      .attr("in", "SourceGraphic");
    this.props.bounds().selectAll('.bar')
      .data(this.props.data)
      .enter()
      .append('rect')
      .attr('x', (d) => (this.props.xScale(d[this.props.xAxisDetail.data_column_name]) + (this.props.xScale.bandwidth() / this.props.yAxisDetails.length) * this.props.idx) + 12)
      .attr('y', (d) => this.props.yScale(this.props.yDataDetail.data_type === 'percent' ? parseFloat(d[this.props.yDataDetail.data_column_name]) * 100 : parseInt(d[this.props.yDataDetail.data_column_name]) > 0 ? parseInt(d[this.props.yDataDetail.data_column_name]) : 0))
      .attr("height", (d) => (parseInt(d[this.props.yDataDetail.data_column_name]) > 0 || this.props.yDataDetail.data_type === 'percent') ? this.props.yScale(0) - this.props.yScale(this.props.yDataDetail.data_type === 'percent' ? parseFloat(d[this.props.yDataDetail.data_column_name]) * 100 : parseInt(d[this.props.yDataDetail.data_column_name])) : this.props.yScale(parseInt(d[this.props.yDataDetail.data_column_name])) - this.props.yScale(0))
      .attr("width", (d) => (this.props.xScale.bandwidth() / this.props.yAxisDetails.length) - 25)
      .attr('fill', this.props.yDataDetail.color)
      .attr('class', (d) => `bar-path bar-${this.props.yDataDetail.data_column_name.toLowerCase().replace(/ /g, "_")}-${this.props.report_details.id} bar-${d[this.props.xAxisDetail.data_column_name].toLowerCase().replace(/ /g, "-")}`)
      .attr('data-xDataColumnName', (d) => `${d[this.props.xAxisDetail.data_column_name].toLowerCase().replace(/ /g, "-")}`)
      .attr('data-yDataColumnName', (d) => `${this.props.yDataDetail.data_column_name}`)


    this.setState({
      hasRunMount: true,
    });
  };

  componentDidUpdate(prevProps) {
    let xScale = d3.scaleBand().domain(this.props.data.map(d => d[this.props.xAxisDetail ? this.props.xAxisDetail.data_column_name : this.props.yAxisDetail.data_column_name])).range([0, this.props.dimensions().boundedWidth]).padding(0.2)
    let yScale = this.props.dataType == 'percent' ? d3.scaleLinear().domain([0, 100]).nice().range([this.props.dimensions().boundedHeight, 0]) : d3.scaleLinear().domain([this.props.yMaxMinDetailndValue.min, this.props.yMaxMinDetailndValue.max]).nice().range([this.props.dimensions().boundedHeight, 0])
    var bars = d3.selectAll(`.bar-${this.props.yDataDetail.data_column_name.toLowerCase().replace(/ /g, "_")}-${this.props.report_details.id}`)
    var passbackToChartWrapper = this.props.onClickToolTip

    var t = d3.transition()
      .duration(750)
      .ease(d3.easeLinear)

    bars
      .data(this.props.data)
      .enter(bars
        .transition(t)
        .attr('x', (d) => (xScale(d[this.props.xAxisDetail.data_column_name]) + (this.props.xScale.bandwidth() / this.props.yAxisDetails.length) * this.props.idx) + 12)
        .attr('y', (d) => yScale(this.props.yDataDetail.data_type === 'percent' ? parseFloat(d[this.props.yDataDetail.data_column_name]) * 100 : parseInt(d[this.props.yDataDetail.data_column_name]) > 0 ? parseInt(d[this.props.yDataDetail.data_column_name]) : 0))
        .attr("height", (d) => (parseInt(d[this.props.yDataDetail.data_column_name]) > 0 || this.props.yDataDetail.data_type === 'percent') ? yScale(0) - yScale(this.props.yDataDetail.data_type === 'percent' ? parseFloat(d[this.props.yDataDetail.data_column_name]) * 100 : parseInt(d[this.props.yDataDetail.data_column_name])) : yScale(parseInt(d[this.props.yDataDetail.data_column_name])) - yScale(0))
        .attr("width", (d) => (xScale.bandwidth() / this.props.yAxisDetails.length) - 25)
      )

    if (this.props.removedDataDetails && this.props.removedDataDetails.length && this.props.removedDataDetails.find(detail => detail.data_column_name === this.props.yDataDetail.data_column_name)) {
      bars
        .transition(t)
        .style("opacity", 0)
    } else {
      bars
        .transition(t)
        .style("opacity", 1)
    };

    function onMouseMove() {
      var bar = d3.select(this);
      var hoverBarSet = d3.selectAll(`.bar-${bar.attr('data-xDataColumnName')}`);

      hoverBarSet.style('filter', function (d) {
        passbackToChartWrapper(d)
        return "url(#drop-shadow)"
      });
    };

    function onMouseLeave() {
      var bar = d3.select(this);
      var hoverBarSet = d3.selectAll(`.bar-${bar.attr('data-xDataColumnName')}`);
      hoverBarSet.style('filter', 'none')
    }

    bars.on('mousemove', onMouseMove)
      .on('mouseleave', onMouseLeave)
  };

  render() {
    return (
      null
    )
  };


};